'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdViewList = function MdViewList(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 8.4h20v6.6h-20v-6.6z m0 23.2v-6.6h20v6.6h-20z m0-8.2v-6.8h20v6.8h-20z m-8.4-8.4v-6.6h6.8v6.6h-6.8z m0 16.6v-6.6h6.8v6.6h-6.8z m0-8.2v-6.8h6.8v6.8h-6.8z' })
        )
    );
};

exports.default = MdViewList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/view-list.js
// module id = 2920
// module chunks = 0